module.exports = __webpack_public_path__ + "img/detalles_servicio.8ad86f68.jpg";